import { useEffect, useState } from 'react';

/**
 * True once the browser has painted at least one frame.
 *
 * Mounting the whole below-fold tree in the first commit meant parsing GSAP
 * ScrollTrigger and running seven section renders before the hero could paint, which
 * put 84% of LCP into render delay. Gating on the second animation frame lets the hero
 * paint first and moves that work off the critical path.
 */
export function useAfterFirstPaint(): boolean {
  const [painted, setPainted] = useState(false);

  useEffect(() => {
    let inner = 0;
    const outer = requestAnimationFrame(() => {
      inner = requestAnimationFrame(() => setPainted(true));
    });

    return () => {
      cancelAnimationFrame(outer);
      cancelAnimationFrame(inner);
    };
  }, []);

  return painted;
}
